import * as yup from 'yup';

export const stationCameraSchema = yup.object({
  stationId: yup.number().required('Station ID is required'),
  title: yup.string().required('Title is required'),
  cameraUrl: yup.string().nullable(),
  name: yup.string().required('Name is required'),
  source: yup.string()
  .required('Source is required')
  .matches(
    /^rtsp:\/\/[^\s]+$/i,
    'Source must be a valid RTSP URL (e.g., rtsp://...)'
  ),
});